import { ComponentTemplateConfig } from "./interfaces/ComponentTemplateConfig";
import { capitalizeFirstLetter, replaceHyphenForCamelCase } from "./utilities";
const ko = require("ko");

export class CustomElement extends HTMLElement {
  // eslint-disable-next-line
  state: any = null;
  shadowDom: ShadowRoot = null;
  templateConfig: ComponentTemplateConfig = null;
  loader: CustomElement = null;
  // eslint-disable-next-line
  viewModel: any = null;
  private _loading = true;

  constructor() {
    super();

    this.state = {};
    this.templateConfig = {
      template: "",
      style: "",
      viewModel: null,
    };
  }

  isCustomElement(element: HTMLElement): boolean {
    return (
      Object.getPrototypeOf(customElements.get(element.tagName.toLowerCase()))
        .name === "CustomElement"
    );
  }

  // updateBindings(prop: string, value = ""): void {
  //   // @ts-ignore
  //   const bindings = [...this.selectAll(`[data-bind$="${prop}"]`)];

  //   bindings.forEach((node) => {
  //     const dataProp = node.dataset.bind;
  //     const bindProp = dataProp.includes(":")
  //       ? dataProp.split(":").shift()
  //       : dataProp;
  //     const bindValue = dataProp.includes(".")
  //       ? dataProp
  //           .split(".")
  //           .slice(1)
  //           // eslint-disable-next-line
  //           .reduce((obj: any, p: any) => obj[p], value)
  //       : value;
  //     // @ts-ignore
  //     const target = [...this.selectAll(node.tagName)].find(
  //       (el) => el === node
  //     );
  //     const isStateUpdate =
  //       dataProp.includes(":") && this.isCustomElement(target);

  //     isStateUpdate
  //       ? target.setState({ [`${bindProp}`]: bindValue })
  //       : this.isArray(bindValue)
  //       ? (target[bindProp] = bindValue)
  //       : (node.textContent = bindValue.toString());
  //   });
  // }

  // eslint-disable-next-line
  setState(newState: any): void {
    Object.entries(newState).forEach(([key, value]) => {
      //@ts-ignore
      this.state[key] =
        this.isObject(this.state[key]) && this.isObject(value)
          ? {
              ...this.state[key],
              // @ts-ignore
              ...value,
            }
          : value;

      // const bindKey = this.isObject(value) ? this.getBindKey(key, value) : key;
      // const bindKeys = this.isArray(bindKey) ? bindKey : [bindKey];

      //@ts-ignore
      // bindKeys.forEach((key) => this.updateBindings(key, value));

      this.checkForWatchers(key);
    });
  }

  // eslint-disable-next-line
  setKeyState(key: string, value: any): void {
    //@ts-ignore
    this.state[key] =
      this.isObject(this.state[key]) && this.isObject(value)
        ? { ...this.state[key], ...value }
        : value;

    // const bindKey = this.isObject(value) ? this.getBindKey(key, value) : key;
    // const bindKeys = this.isArray(bindKey) ? bindKey : [bindKey];

    //@ts-ignore
    // bindKeys.forEach((key) => this.updateBindings(key, value));

    this.checkForWatchers(key);
  }

  // eslint-disable-next-line
  getBindKey(key: any, obj: any): any {
    return Object.keys(obj).map((k) =>
      this.isObject(obj[k])
        ? `${key}.${this.getBindKey(k, obj[k])}`
        : `${key}.${k}`
    );
  }

  // eslint-disable-next-line
  isArray(arr: any): boolean {
    return Array.isArray(arr);
  }

  // eslint-disable-next-line
  isObject(obj: any): boolean {
    return Object.prototype.toString.call(obj) === "[object Object]";
  }

  select(selector: string): HTMLElement {
    return this.shadowRoot
      ? this.shadowRoot.querySelector(selector)
      : this.querySelector(selector);
  }

  selectAll(selector: string): NodeList {
    return this.shadowRoot
      ? this.shadowRoot.querySelectorAll(selector)
      : this.querySelectorAll(selector);
  }

  // eslint-disable-next-line
  multiSelect(config: any): void {
    Object.entries(config).forEach(([prop, selector]) => {
      //@ts-ignore
      this[prop] = this.select(selector);
    });
  }

  // eslint-disable-next-line
  show(els: any = null): void {
    const elems = els || this;
    const elements =
      // eslint-disable-next-line
      Array.isArray(elems) || NodeList.prototype.isPrototypeOf(elems)
        ? elems
        : [elems];

    // eslint-disable-next-line
    elements.forEach((element: any) => {
      element.style.display = "";
      element.removeAttribute("hidden");
    });
  }

  // eslint-disable-next-line
  hide(els: any = null): void {
    const elems = els || this;
    const elements =
      // eslint-disable-next-line
      Array.isArray(elems) || NodeList.prototype.isPrototypeOf(elems)
        ? elems
        : [elems];

    // eslint-disable-next-line
    elements.forEach((element: any) => {
      element.style.display = "none";
      element.setAttribute("hidden", "");
    });
  }

  // eslint-disable-next-line
  css(els: any, styles: any): void {
    const elements = Array.isArray(els) ? els : [els];
    elements.forEach((element) => Object.assign(element.style, styles));
  }

  // eslint-disable-next-line
  addTemplate(element: any, selector: any, replaceContents = false): void {
    //@ts-ignore
    const template = this.select(selector).content.cloneNode(true);
    replaceContents ? (element.innerHTML = "") : null;

    element.appendChild(template);
  }

  setupComponent(useShadowDom = true): void {
    // eslint-disable-next-line
    let dom: any = this;
    if (useShadowDom) {
      this.shadowDom = this.attachShadow({ mode: "open" });
      dom = this.shadowDom;
    }

    if (this.templateConfig.template !== "") {
      const wrap = document.createElement("template");
      wrap.innerHTML = this.templateConfig.template;
      dom.appendChild(wrap.content);
    }

    if (this.templateConfig.style !== "") {
      const css = document.createElement("style");
      css.innerHTML = this.templateConfig.style;
      dom.appendChild(css);
    }

    if (this.templateConfig.viewModel) {
      this.viewModel = new this.templateConfig.viewModel.default(this);
      // eslint-disable-next-line
      Array.from(this.shadowDom.children).forEach((element: any) => {
        ko.applyBindings(this.viewModel, element);
      });
    }

    const loader: CustomElement = dom.querySelector("ccc-loader.automatic");
    if (loader) {
      this.loader = loader;
    }
  }

  checkForWatchers(key: string): void {
    // eslint-disable-next-line
    const watchFunction: any =
      "watch" + capitalizeFirstLetter(replaceHyphenForCamelCase(key));
    console.debug("Custom Element", "Check for watchers", watchFunction);

    // @ts-ignore
    if (this[watchFunction] && typeof this[watchFunction] === "function") {
      console.debug("Custom Element", "Watcherfound", watchFunction);
      //console.log("WATCHER FOUND ", watchFunction);
      // @ts-ignore
      this[watchFunction].call(this);
    }
  }

  /**
   * @deprecated please use setter for loading
   * Sets loading
   * @param visible
   */
  setLoading(visible: boolean): void {
    this.loading = visible;
  }

  public get loading(): boolean {
    return this._loading;
  }
  public set loading(state: boolean) {
    if (this.loader) {
      // console.log(this.loader);
      this.loader.setAttribute("visible", state ? "1" : "0");
    }
    this._loading = state;
  }

  attributeChangedCallback(
    attr: string,
    _oldValue: unknown,
    newValue: unknown
  ): void {
    console.debug("State from custom element class", this);
    const attrNormalized = replaceHyphenForCamelCase(attr);
    if (
      this.state !== null &&
      Object.hasOwnProperty.call(this.state, attrNormalized)
    ) {
      if (_oldValue === null) {
        this.setKeyState(attrNormalized, newValue);
      }
    }
  }
}

export function Component(
  selector: string,
  templateConfig: ComponentTemplateConfig,
  useShadowDom = true
) {
  return function <
    T extends {
      // eslint-disable-next-line
      new (...args: Array<any>): {
        templateConfig: ComponentTemplateConfig;
        setupComponent: (useShadowDom?: boolean) => void;
      };
    }
  >(constructor: T): T {
    if (templateConfig.observedAttributes) {
      Object.defineProperty(constructor, "observedAttributes", {
        get: function () {
          return templateConfig.observedAttributes;
        },
      });
    }

    const extendedClass = class extends constructor {
      // eslint-disable-next-line
      constructor(...args: Array<any>) {
        super(...args);
        this.templateConfig = templateConfig;
        this.setupComponent(useShadowDom);
      }
    };

    if (!customElements.get(selector)) {
      customElements.define(
        selector,
        extendedClass as unknown as CustomElementConstructor
      );
    }

    return extendedClass;
  };
}
